import { QueryClient } from '@tanstack/react-query';

/** Shared query client. Conservative retries so error states surface honestly. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 15_000 },
  },
});
